<div class="payment-dialog" mat-dialog-content>
  <div class="header">
    <div>
      <p class="eyebrow">Payment</p>
      <h2>Invoice #{{data.invoiceNumber}}</h2>
      <p class="subtitle">{{ customerName || 'No customer' }}</p>
    </div>
    <div class="pill">
      {{ data.invoiceStatus || 'unknown' }}
    </div>
  </div>

  <div class="grid">
    <button type="button" class="card button-card" (click)="searchByAmount()" [disabled]="isLoadingSuggestions || data.payment?.amount == null">
      <p class="label">Amount</p>
      <div class="value">{{ data.payment?.amount | human }}</div>
      <p class="hint">Method: {{ data.payment?.method || '—' }}</p>
      <p class="action-hint">Click to find matching transactions</p>
    </button>
    <div class="card">
      <p class="label">Date received</p>
      <div class="value">{{ data.payment?.date | date:'dd MMM yyyy, h:mm a' }}</div>
      <p class="hint">Recorded on invoice {{ data.dateCreated | date:'dd MMM yyyy' }}</p>
    </div>
    <div class="card">
      <p class="label">Invoice totals</p>
      <div class="value">{{ data.total | human }}</div>
      <p class="hint">Outstanding: {{ data.amountDue | human }}</p>
    </div>
    <div class="card" *ngIf="data.transactionSha1">
      <p class="label">Linked transaction</p>
      <div class="value mono">{{ data.transactionSha1 }}</div>
      <p class="hint">Payment ID: {{ data.payment?.paymentId || 'n/a' }}</p>
    </div>
  </div>

  <div class="linker">
    <div class="row">
      <div>
        <p class="label">{{ data.transactionSha1 ? 'Update link' : 'Link to transaction' }}</p>
        <p class="hint">Enter the transaction hash to bind this payment.</p>
      </div>
      <mat-form-field appearance="outline" class="hash-input">
        <mat-label>Transaction hash</mat-label>
        <input matInput [(ngModel)]="transactionSha1Input" [disabled]="isLinking">
      </mat-form-field>
      <button mat-raised-button color="primary" (click)="linkTransaction()" [disabled]="isLinking || !transactionSha1Input">
        {{ data.transactionSha1 ? 'Update link' : 'Link' }}
      </button>
    </div>
    <p class="error" *ngIf="linkError">{{ linkError }}</p>
  </div>

  <div class="suggestions" *ngIf="hasSearchedSuggestions || suggested.length || isLoadingSuggestions">
    <div class="row header">
      <p class="label">{{ suggestionLabel }}</p>
      <mat-spinner diameter="18" *ngIf="isLoadingSuggestions"></mat-spinner>
    </div>
    <div class="suggestion" *ngFor="let tx of suggested">
      <div>
        <div class="desc">{{ tx.description || 'No description' }}</div>
        <div class="meta">
          <span>{{ tx.date | date:'dd MMM yyyy' }}</span>
          <span class="dot">•</span>
          <span>{{ tx.amount | human }}</span>
        </div>
      </div>
      <button mat-stroked-button color="primary" (click)="useSuggestion(tx)">Link</button>
    </div>
    <p class="hint" *ngIf="!suggested.length && !isLoadingSuggestions">No suggestions found yet.</p>
  </div>

  <div class="notes" *ngIf="data.payment?.note">
    <p class="label">Note</p>
    <p class="note-body">{{ data.payment?.note }}</p>
  </div>
</div>

<div mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close>Close</button>
</div>
